<template>
    <component :is="'tr'" :class="getClass()" v-bind="bindData">
        <component :is="cell" v-for="(cell, i) in cells()" :key="i" />
    </component>
</template>

<script lang="ts" setup>
import type { Header } from '../helpers';
import { travel } from '../helpers';

defineOptions({
    components: {
        vnodes: (props: Record<string, any>, context: any) => props.vnodes
    },
    inheritAttrs: false
});

export interface Props
{
    index: number;
    item: any;
    headers: Header[];
}

const $slots = useSlots() as any;
const $attrs = useAttrs() as any;
const props = withDefaults(defineProps<Props>(), {});
const item = computed(() => props.item);
const rowClass = inject<(item: any, i: number) => Record<string, boolean> | string[] | string>('row-class');
const draggable = inject<boolean>('draggable');

const bindData = computed(() => ({
    'data-draggable': $attrs['data-draggable'],
    'draggable': $attrs.draggable,
    'style': $attrs.style
}));

provide('item', item);

const getClass = (): any =>
{
    const classes = { draggable: draggable };

    if (rowClass)
    {
        return Object.assign(classes, rowClass(props.item, props.index));
    }

    return classes;
};

const cells = (): any[] =>
{
    const allowed = [
        'ListViewHeader',
        'ListViewItem',
        'ListViewLabel',
        'ListViewButtons',
        'ListViewImage',
        'ListViewCheckbox',
        'ListViewHierarchy',
        'ListViewHandle'
    ];
    const prefix = (new Date()).getTime();

    return travel($slots.default(), allowed)
        .map((p, i) =>
        {
            p.key = `${prefix}-${i}`;
            p.props = p.props || {};
            p.props.index = i;
            p.props.header = props.headers[i];

            return p;
        })
        .filter(p => !p.props.header.disabled)
        .orderBy(p => p.props.header.position)
        .toArray();
};
</script>
